export default __webpack_public_path__ + "static/media/ava_epstein.a4b05ce0.jpg";